import React from "react";
import { useNavigate } from "react-router-dom";
import { urlFor, client } from '../../../lib/client';
import "./Product.scss";

const Product = ({data}) => {
    console.log(data)
    const navigate = useNavigate();
    return (
        <div
            className="product-card"
            onClick={() => navigate("/product/" + data?._id)}
        >
            <div className="thumbnail">
            <img
              src={
                urlFor(data.image[0])
              } alt={data.brand}
            />
            </div>
            <div className="prod-details">
                <span className="name">{data.name}</span>
                <span className="price">£{data.price}</span>
            </div>
        </div>
    );
};

export default Product;
